<template>
    <b-container>
        <b-tabs content-class="mt-3">
            <b-tab title="Editor" active>

                <b-input v-model="doc.title" class="mb-2"></b-input>
                <div class="doceditor">
                    <ckeditor :editor="editor" v-model="doc.body" :config="editorConfig"></ckeditor>
                    
                    <b-button variant="primary" class="float-right mt-2" @click="saveForm()"><font-awesome-icon
                            :icon="['fa-solid', 'fa-floppy-disk']" /> Save Doc</b-button>

                </div>
            </b-tab>
            <b-tab title="Link">
                <div class="row">
                    <div class="col-10">
                        <h1>Link to Aspect or Policy</h1>
                    </div>
                    <div class="col-2">
                        <b-button v-b-modal.modal-link class="btn float-right btn-secondary btn-block">New
                            Link</b-button>
                        <b-modal id="modal-link" title="Link to Aspect or Policy">
                            <b-input v-model="link_search"></b-input>
                            <b-list-group>
                                <b-list-group-item v-for="link in link_results" :key="link.id">{{ link.title
                                    }} <b-button v-on:click="addLink(link.id)"><font-awesome-icon
                                            :icon="['fa-solid', 'fa-link']" /> Link</b-button></b-list-group-item>
                            </b-list-group>

                        </b-modal>
                    </div>
                </div>
                <table class="table striped hover" v-if="links.length > 0">
                    <tr v-for="link in links" :key="link.id">
                        <td><a :href="link.url">{{ link.name }}</a></td>
                        <td align="right"><b-button v-on:click="unLink(link.id)"
                                class="btn btn-sm btn-danger">Unlink</b-button></td>
                    </tr>

                </table>
                <b-alert v-if="links.length == 0" show>No links</b-alert>
            </b-tab>
            <b-tab title="Clone" v-on:click="clone()"></b-tab>
            <b-tab title="Download PDF" v-on:click="downloadPDF()"></b-tab>
        </b-tabs>

    </b-container>
</template>
<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import DocDataService from '@/services/DocDataService';
import SearchDataService from '@/services/SearchDataService';

export default {
    props: ["list"],
    data() {
        return {
            doc: [],
            link_search: '',
            link_results: [],
            links: [],
            editor: ClassicEditor,
            editorConfig: {}
        }
    },
    created() {
        DocDataService.getById(this.$route.params.id).then((res) => {
            this.doc = res.data;
        });

        this.getLinks()

    },
    methods: {
        saveForm() {
            DocDataService.update(this.doc.id, this.doc).then(() => {
                this.$emit("saved");
            });
        },
        addLink(id) {
            DocDataService.link(this.doc.id, id).then(() => {
                this.getLinks();
            })
        },
        unLink(refid) {
            DocDataService.unlink(this.doc.id, refid).then(() => {
                this.getLinks();
            })
        },
        getLinks(refid) {
            DocDataService.getLinks(this.$route.params.id, refid)
                .then((res) => {
                    console.log(res);
                    this.links = res; // Set the links if the response is valid
                })
                .catch((error) => {
                    // Handle 404 errors specifically
                    if (error.response && error.response.status === 404) {
                        const link_error = error.response.data?.error;
                        if (link_error === 'No document references found.') {
                            console.warn('No document references found for this ID.');
                            this.links = []; // Clear links if no references are found
                        }
                    } else {
                        // Handle other errors
                        console.error('Unexpected error fetching links:', error);
                        this.links = []; // Clear links on unexpected errors
                    }
                });
        },
        downloadPDF() {
            DocDataService.downloadPDF(this.$route.params.id).then((res) => {
                // res is already the blob since makeRequest returns response.data
                const blob = res instanceof Blob ? res : new Blob([res], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = (this.doc?.title || 'document') + ".pdf";
                link.click();
                // Clean up the URL object
                window.URL.revokeObjectURL(link.href);
            }).catch((err) => {
                console.error('Failed to download PDF:', err);
            });
        },
        clone() {
            window.location = '/doc/create?clone=' + this.$route.params.id
        }
    },
    watch: {
        link_search: function () {
            if (this.link_search.length < 2) return;

            clearTimeout(this.debounce);

            this.debounce = setTimeout(() => {
                SearchDataService.search(this.link_search).then((res) => {
                    let results = res.data;

                    results.forEach((result) => {
                        let url = result.url;

                        url = url.replace("aspect/view", "aspect");
                        url = url.replace("policies/view", "policy");

                        let id = url.split('/').filter(Boolean).pop();

                        let obj = {
                            title: result.title,
                            url: url,
                            id: id
                        };

                        this.link_results.push(obj);
                    });

                });
            }, 400);
        }
    }
}

</script>
<style>
.doceditor .ck-editor__editable {
    min-height: 73vh !important;
}
</style>